'use client';
import { useButton } from '@react-aria/button';
import e from 'prop-types';
import e__default from 'react';
import { useFloatingLabelFormElement } from '../../contexts/internal/floating-label/index.js';
import { useSwanListboxButtonContext } from './listbox-button.context.js';
import { useSelectedItems } from './use-selected-items.hook.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for(o = 0; o < l.length; o++)r = l[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, l = Object.keys(e);
    for(o = 0; o < l.length; o++)r = l[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let s = Object.keys({
    labelPrefix: e.node,
    placeholder: e.node
}), SelectedOptions = ({ className: e, placeholder: t })=>{
    let { selectedItems: o, selectedItemsOrFirst: n } = useSelectedItems(), l = '';
    if (0 === o.length && null != t) l = t;
    else if (1 === n.length) {
        var i, p, c, s;
        let e = n[0];
        l = null !== (s = null !== (c = null !== (p = null == e ? void 0 : null === (i = e.props) || void 0 === i ? void 0 : i.label) && void 0 !== p ? p : null == e ? void 0 : e.rendered) && void 0 !== c ? c : null == e ? void 0 : e.textValue) && void 0 !== s ? s : '';
    } else l = n.reduce((e, t, o)=>{
        var l, i, p, c;
        let a = null == t ? void 0 : t.props, s = null !== (i = null == t ? void 0 : null === (l = t.value) || void 0 === l ? void 0 : l.toString()) && void 0 !== i ? i : o, u = [
            ...e,
            e__default.createElement(e__default.Fragment, {
                key: s
            }, null !== (c = null !== (p = a.label) && void 0 !== p ? p : null == t ? void 0 : t.rendered) && void 0 !== c ? c : null == t ? void 0 : t.textValue)
        ];
        return o < n.length - 1 && u.push(e__default.createElement(e__default.Fragment, {
            key: `${s},`
        }, ', ')), u;
    }, []);
    return e__default.createElement("span", {
        className: e
    }, l);
};
const ListboxButton = renderWithRef('ListboxButton', {}, (t, l)=>{
    var { className: a, labelPrefix: u } = t, b = _object_without_properties(t, [
        "className",
        "labelPrefix"
    ]);
    let { triggerRef: d } = useSwanPopover(), { triggerProps: f, triggerDisabled: m } = useSwanListboxButtonContext(), y = assignRefs(l, d), { buttonProps: O } = useButton(f, d), _ = O.id;
    useFloatingLabelFormElement(_object_spread_props(_object_spread({}, b), {
        placeholder: void 0,
        id: _
    }));
    let v = new Set([
        'swan-listbox-button'
    ]);
    return u && v.add('swan-listbox-button-with-label'), a && v.add(a), e__default.createElement(RenderComp, {
        root: "button",
        forwardedRef: y,
        classNames: v,
        props: _object_spread_props(_object_spread({}, b, O), {
            disabled: m
        }),
        propKeysToRemove: s
    }, u ? e__default.createElement("span", {
        className: "swan-listbox-button-label"
    }, u) : null, e__default.createElement(SelectedOptions, {
        placeholder: b.placeholder
    }));
});

export { ListboxButton };
